import z from 'zod';
import { Locale } from './enums';
const options = Object.values(Locale);
export const locale = z.string()
    .transform((input) => (options.includes(input) ? input : Locale.en))
    .describe(`Locale, accepts the following values. '${options.join(', ')}', default to en otherwise.`);
